export const DocumentVI = {

    DGDocument: {
        heading: {
            rename: "Đổi tên",
            create: "Tạo thư mục",
            personal: "Tài liệu cá nhân",
            attach: "Tài liệu đính kèm",
            company: {
                all: "Tài liệu công ty",
            },
            favouriteFile: "Tài liệu yêu thích",
            move: "Di chuyển",
            delete:`Bạn có chắc chắn là muốn xóa tệp {{name}} không?`,
            attachList: "Danh sách đính kèm",
        },
        label: {
            name: "Tên",
            creator: "Người tạo",
            type: "Loại",
            size: "Dung lượng",
            modifiedDate: "Chỉnh sửa lần cuối",
            sharedObjects: "Được chia sẻ",
            module: {
                type: "Loại đối tượng"
            },
            object: "Đối tượng",
            isEdit: "Chỉnh sửa",
            projectObject: "Giai đoạn và Công việc",
            createDate: "Ngày tạo"
        },
        placeholder: {
            search: "Tìm kiếm",
            folder: "Tên thư mục"
        },
        action: {
            clone: "Tạo bản sao",
            move: "Di chuyển",
            add: {
                folder: "Tạo thư mục",
                file: "Tải tệp lên"
            },
            upload: {
                folder: "Tải thư mục lên"
            },
            update: {
                true: "Công khai",
                false: "Riêng tư"
            },
            favorite: {
                love: "Yêu thích",
                inLove: "Bỏ yêu thích"
            },
            rename: "Đổi tên",
            delete: "Xóa",
            download: "Tải xuống",
            preview: "Mở tệp",
            back: "Trở lại",
            view: {
                list: "Dạng danh sách",
                grid: "Dạng lưới"
            },
            cancel: "Hủy",
            detail: "Chi tiết",
            open: "Mở"
        },
        button: {
            update: "Đổi tên",
            create: "Tạo",
            cancel: "Đóng"
        },
        description: {
            drag: {
                title: " hoặc kéo thả tệp để tải lên",
                hint: "Tệp tải lên có dung lượng không quá 2M"
            }
        },
        text: {
            to: "đến",
            onclick: "Bấm vào đây ",
            toTry: "Để thử lại",
            file: "tệp ",
            folder: "thư mục"
        },
        message: {
            success: {
                download: "Tải thành công",
                move: "Chuyển thành công"
            },
            validator: {
                file: {
                    size: "Tệp video chỉ dưới 10mb và các tệp khác chỉ được dưới 5mb",
                    is: "Chỉ chấp nhận tệp video, ảnh, audio, tài liệu, trang tính, trình chiếu"
                },
                folder: "Không thể tải lên thư mục trống"
            },
            warning: {
                delete: "Bạn có muốn xóa tệp không"
            }
        },
        value: {
            time: {
                year: "năm trước",
                month: "tháng trước",
                day: "ngày trước",
                hour: "giờ trước",
                minute: "phút trước",
                second: "giây trước"
            },
            isEdit: {
                yes: "Có"
            }
        },
        modules: {
            PERSONNEL: "Nhân sự",
            APPLICATION: "Đơn từ",
            WORK: "Công việc",
            DECISION: "Quyết định"
        },
        apps: {
            PERSONNEL: {
                RECORD: "Hồ sơ nhân sự",
                LABEL_CONTRACT: "Hợp đồng",
                DECISION: "Quyết định"
            },
            APPLICATION: {
                CHECK_IN_OUT: "Đơn check in check out",
                ABSENCE: "Đơn vắng mặt",
                RESIGN: "Đơn nghỉ việc",
                SHIFT_SWAP: "Đơn đổi ca",
                MISSION: "Đơn công tác",
                OVERTIME: "Đơn tăng ca",
                SHIFT_MORE: "Đơn làm thêm",
                FLEXIBLE: "Đơn làm theo chế độ",
                LEAVE: "Đơn xin nghỉ",
                SHIFT_REGISTRATION: "Đơn đăng ký ca",
                LATE_EARLY: "Đơn xin đi sớm về muộn"
            },
            WORK: {
                NORMAL: "Công việc thường",
                PROJECT: "Dự án",
                PROCESS: "Công việc quy trình",
                PHASE: "Giai đoạn",
                SEQUENCE: "Công việc tuần tự"
            },
            DECISION: {
                SALARY: "Quyết định tăng giảm lương",
                DISMISSAL: "Quyết định miễn nhiệm",
                DISCIPLINE: "Quyết định kỷ luật",
                REWARD: "Quyết định khen thưởng",
                TRANSFER: "Quyết định điều chuyển",
                APPOINTMENT: "Quyết định bổ nhiệm",
                ADMISSION: "Quyết định tiếp nhận",
                CONTRACT: "Quyết định chấm dứt hợp đồng"
            }
        }
    }
}
